<template>
  <div class="maps card">
    <div class="maps--top">
      <div class="selects">
        <div class="select">
<!--          <label> {{ translate('client.list') }} </label>-->
          <tree-select
              v-model="client_list_ids"
              :options="client_list"
              :placeholder="translate('client.list')"
              :clearable="true"
              :multiple="true"
              @input="change_list_ids('client_list_ids')"
              :disabled="loading"
          />
        </div>

        <div class="select">
<!--          <label> {{ translate('custom.title') }} </label>-->
          <tree-select
            v-model="device_list_ids"
            :options="device_list"
            :placeholder="translate('custom.title')"
            :clearable="true"
            :multiple="true"
            @input="change_list_ids('device_list_ids')"
            :disabled="loading"
          />
        </div>
      </div>

      <div class="dashboard_details" v-if="$store.getters.getPermissions.viewDashboardMapDetails === true && Object.values(dashboard_details).length > 0">
        <div  class="dashboard_details--item card info">
          <p>Total:{{ dashboard_details.total }}</p>
          <p>Online:{{ dashboard_details.online }}</p>
        </div>

        <div class="dashboard_details--item card country">
          <p
              v-for="(country, key ) in dashboard_details.country_data"
              :key="key"
          >
            <CountryFlags :country="country.name"/>
            <span> {{ country.name }} : {{ country.value }}</span>
          </p>
        </div>
      </div>
    </div>

      <div class="card-map">
        <div class="info_window" v-if="device_info && infoBoxOpen">
          <div class="top">
            <div class="miniblock status_info card" :class="{ online: device_info.uptime?.status, offline: !device_info.uptime?.status, backup: device_info.backup, blocked: device_info.block_status?.status}">
              <div class="icons">
                <span class="icon mdi mdi-access-point-off offline" v-if="!device_info.uptime?.status"/>
                <span class="icon mdi mdi-access-point online" v-if="device_info.uptime?.status"/>
                <span class="icon mdi mdi-server-network backup" v-if="device_info.backup"/>
                <span class="icon mdi mdi-lock-alert blocked" v-if="device_info.block_status?.status"/>
              </div>

              <div class="text">
                <p>
                  {{ !device_info.uptime ? '' : (device_info.uptime.status) ? translate('filter.status.online') : translate('filter.status.offline') }}
                </p>
                <p>
                  {{ uptimeStr }}
                </p>
                <p>
                  {{ last_date }}
                </p>
              </div>
              <div v-if="device_info.backup" class="backup">
                <p>
                  IP: {{ device_info.backup?.ip }}
                </p>
                <p>
                  Server: {{ device_info.backup?.server }}
                </p>
              </div>
            </div>

            <div
                v-for="(device_traffic, device_traffic_key) in device_info.traffic"
                :key="device_traffic_key"
                v-if="Object.keys(device_traffic).length > 0" class="traffic__block"
            >
              <div class="graph_wrap" v-if="device_traffic.is_unlim === false">
                <span class="graph" :style="trafficBalance(device_traffic).style"/>
              </div>

              <p class="rest" :class="{unlim: device_traffic.is_unlim === true}">
                <span v-if="device_traffic.is_unlim === true" class="mdi mdi-infinity" />
                <span class="tariff_name">
                  {{ device_traffic.packet_name }}
                </span>
                <span v-if="device_traffic.is_unlim === false">
                  <b :style="'color:' + trafficBalance(device_traffic).color">
                    {{ trafficBalance(device_traffic).traffic }}
                  </b>
                  {{ translate("simcard_devices.out_of") }}
                  <b>
                    {{ device_traffic.limit > 1024 * 5 ? Math.round(device_traffic.limit / 1024) + ' GB' : device_traffic.limit + ' MB' }}
                  </b>
                </span>
              </p>
            </div>
          </div>

          <div class="bottom">
            <div class="device_info">
              <div class="bottom__wrap">
                <router-link :to="'/device/' + device_info.fid">
                  {{ device_info.name }}
                </router-link>
                <router-link :to="'/device_list?group=' + device_info.group_id">
                  {{ device_info.group_name }}
                </router-link>
              </div>
              <p v-if="device_info.location"> {{ device_info.location?.country }}, {{ device_info.location?.city }}</p>
            </div>
            <div class="simcard_info">
              <div class="response_table" v-if="simcard_list.length > 0">
                <table>
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ translate("simcard_devices.slot") }}
                      </th>
                      <th scope="col">
                        {{ translate("simcard_devices.status") }}
                      </th>
                      <th scope="col">
                        {{ translate("simcard_devices.mno") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr
                          v-for="(sim, key) in sims_list"
                          :key="key"
                          class="pointer"
                          :class="{ our_sim: sim.simcard_profile !== null }"
                      >
                        <td class="slot" :data-label="translate('simcard_devices.slot')">
                          {{ sim.slot }}
                        </td>

                        <td :data-label="translate('simcard_devices.status')" class="sim_status">
                          <div
                              v-if="sim.sim_state"
                              class="sphere"
                              :style="'background-color:' + sim.sim_state.color"
                          >
                            <span
                                v-if="sim.active"
                                class="mdi mdi-check-circle-outline"
                            />
                            <span
                                v-else
                                class="mdi mdi-checkbox-blank-circle-outline"
                            />
                          </div>
                        </td>

                        <td :data-label="translate('simcard_devices.mno')">
                          {{ sim.mno }}
                        </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <span class="mdi mdi-close close" @click="closeInfoWindow"/>
        </div>

        <div class="loading" v-if="loading">
          <div style="height: 100%">
            <div class="spinner">
              <scale-loader />
            </div>
          </div>
        </div>

        <gmap-map
          :zoom="3"
          :center="center"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: true,
            fullscreenControl: true,
            disableDefaultUi: false
          }"
          style="width: 100%; height: 100%"
          @click="click_find_distance"
          @rightclick="rightclick_find_distance"
        >

          <template v-for="(coords, device_id) in all_coords">
            <gmap-polyline
              :path="coords"
              :options="{
                strokeColor:'#000000',
                strokeOpacity: 1.0,
                strokeWeight: 0.5,
                icons: [{
                  icon: {
                    path: 1,
                    scale: 3
                  },
                  offset: '1'
                }]
              }"
            />

            <gmap-marker
                v-for="(item, index) in coords"
                :key="device_id+index"
                :position="item"
                :icon="item.icon"
                :clickable="true"
                :draggable="false"
                @click="openInfoWindow(item, 'first')"
                @rightclick="openInfoWindow(item, 'second')"
            />

          </template>

          <!-- Элементы карты необходимые для линейки -->

          <gmap-marker
            v-for="(marker, index) in distance_markers"
            :key="'distance'+index"
            :position="marker"
            :icon="{ url: require('assets/icons/sistematics_dist.png')}"
            :draggable="false"
          />

          <gmap-polyline
            :path="distance_markers"
            :coords.sync="distance_markers"
            :options="{
              strokeColor:'#7f058f',
              strokeOpacity: 1.0,
              strokeWeight: 3,
              icons: [{
                icon: {
                  path: 0,
                  scale: 3
                },
                offset: '1',
                repeat: '100px'
              }]
            }"
          />

          <gmap-info-window
            :options="{
              maxWidth: 300,
              pixelOffset: {
                width: 0,
                height: -10
              },
              content: distanceInfo,
              strokeColor:'#FF0000'
            }"
            :position="distancePos"
            :opened="distanceOpen"
            @closeclick="clear_find_distance()"
        >
        </gmap-info-window>

        <!-- Конец элементов карты необходимых для линейки -->
      </gmap-map>
    </div>
  </div>
</template>

<script>


import CountryFlags from "components/UIComponents/CountryFlags/CountryFlags.vue";

export default {
  name: 'DashboardMaps',
  components: {CountryFlags},

  data () {
    return {
      dashboard_details: {
         total: 0,
         online: 0,
         country_data: []
      },
      device_list_ids: [],
      client_list_ids: [],
      focus: {},
      all_coords: [],
      simcard_list: [],
      device_info: {},
      infoBoxOpen: false,
      interval: null,
      statusText: '',
      center: {lat: 0, lng: 0},
      showdatetrack: false,
      show_last_position: true,
      show_last_info: true,

      distanceInfo: '',
      distanceOpen: false,
      distancePos: {lat: 0, lng:0},
      distance_markers: [],

      loading: true,
      first_req: true
    }
  },

  watch:{
    focus(){
      if (this.focus.lat && this.focus.lng) {
        this.center = this.focus
      }
    },
    device_list_ids(){
      if (this.device_list_ids.length < 1){
        this.all_coords = {}
      }
    },
    // client_list_ids(){
    //   if (this.client_list_ids.length < 1){
    //     this.all_coords = {}
    //   }
    // },
  },

  created() {
    this.dashboard_device_map()
  },

  computed:{
    sims_list() {
      return this.simcard_list.filter((simcard) => {
        return simcard.active === 1
      });
    },
    client_list () {
      return this.$store.getters.getClientsList.map((client) => {
        return {id: client.id, label: client.name}
      })
    },
    device_list () {
      return this.$store.getters.getCustomList.map((item) => {
        return {id: item.id, label: item.name}
      })
    },
    final_distance() {
      let lat1,lon1,lat2,lon2
      for (let marker of this.distance_markers) {
        if (marker.type === 'first') {
          lat1 = marker.lat
          lon1 = marker.lng
        }else if (marker.type === 'second') {
          lat2 = marker.lat
          lon2 = marker.lng
        }
      }

      let R = 6371000; // Radius of the earth in m
      let dLat = this.deg2rad(lat2-lat1);  // deg2rad below
      let dLon = this.deg2rad(lon2-lon1);
      let a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
        ;
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      let d = R * c; // Distance in m
      return Math.trunc(d)
    },
    last_date(){
      let timeUp = Math.round(Date.now() / 1000) - (this.device_info.uptime?.status_ts + 1)
      let days = Math.floor((timeUp / 86400))
      let str = ''
      if (days > 7){
        str += this.get_date(this.device_info.uptime.status_ts, {
          hour12: false,
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        })
      }
      return str
    },
    uptimeStr () {
      let str = ''

      if (this.device_info.uptime !== null) {
        let timeUp = Math.round(Date.now() / 1000) - (this.device_info.uptime?.status_ts + 1)

        let days = Math.floor((timeUp / 86400))
        str += (days > 0) ? days + ' ' + this.translate('date.d') + ' ': ''

        let hours = Math.floor((timeUp % 86400) / 3600)
        str += (hours > 0) ? hours + ' ' + this.translate('date.h') + ' ': ''

        let min = Math.floor((timeUp % 3600) / 60)
        str += min + ' ' + this.translate('date.min') + ' '

        if (!days){
          let sec = Math.floor((timeUp % 60))
          str += sec + ' ' + this.translate('date.sec') + ' '
        }
      }else{
        str += this.translate('device.off_forever')
      }

      return str
    },
  },

  methods: {
    get_date_with_check(ts) {
      const currentDate = new Date();
      const timestamp = currentDate.getTime() / 1000;
      if (timestamp < ts + 60) {
        return "now";
      }
      return this.get_date_short(ts);
    },
    trafficBalance(data) {
      if (!data) return null

      let traffic_GB = +data.value / 1024
      let percent = Math.round((+data.value / +data.limit) * 100)
      let color = percent <= 10 ? '#FF0000' : percent >= 25 ? '#01AA88' : '#FFA200'

      return {
        traffic: traffic_GB > 5 ? Math.round(traffic_GB) + " GB" : data.value + " MB",
        style: "--p:" + percent + ";" + ";--c:" + color + ";--b:3px;--lw:" + percent + "%",
        percent,
        color
      }
    },
    icon_map(device){
      let six_hours = 6*60*60
      let one_day = 24*60*60
      let seven_day = 7*24*60*60

      if (((device.last?.ts + six_hours)*1000) < new Date().getTime()){
        let result = {
          path: 0,
          scale: 5,
          strokeColor: "",
          fillColor: '',
          fillOpacity: 0
        }
        let diff_ts = new Date().getTime() - device.last?.ts*1000
        if(diff_ts < one_day*1000){
          result.strokeColor = "yellow"
        }else if((diff_ts < seven_day*1000)){
          result.strokeColor = "orange"
        }else{
          result.strokeColor = "red"
        }
        return result
      }else{
        return (device.online) ? { url: require('assets/icons/sistematics_online.png')} : { url: require('assets/icons/sistematics_offline.png')}
      }
    },

    dashboard_device_map(){
      this.closeInfoWindow()
      this.loading = true

      let params = {}
      this.device_list_ids.length > 0 ? params.device_lists = JSON.stringify(this.device_list_ids) : ''
      this.client_list_ids.length > 0 ? params.client_ids = JSON.stringify(this.client_list_ids) : ''

      this.$http.v1.dashboardDeviceMap(params, (response) => {
        if(this.$store.getters.getPermissions?.viewDashboardMapDetails === true) {
          this.$http.v1.dashboardDeviceMapDetails(params, (response) => {

            let country_data = Object.keys(response.data.country_data).map((item) => {
              return { name: item, value: response.data.country_data[item]}
            })
            country_data = country_data.sort((a, b) => a.value < b.value ? 1 : -1)
            this.dashboard_details = {
              ...response.data, country_data: country_data
            }
          });
        }
        let map_stat = response.data
        let aver_lat = 0
        let aver_lng = 0
        let count = 0
        let list = {}
        for (let map in map_stat) {
          if ( map_stat[map].last != null) {
            let item = []
            if (map_stat[map].stand === false){
              item.push({
                'lat': parseFloat(map_stat[map].past.lat),
                'lng': parseFloat(map_stat[map].past.lng),
                'ts': map_stat[map].past.ts,
                'fid': map_stat[map].fid,
                'icon': { path: 0, scale: 3, strokeColor: '', fillColor: '', fillOpacity: 0},
              })
            }

            item.push({
              'lat': parseFloat(map_stat[map].last.lat),
              'lng': parseFloat(map_stat[map].last.lng),
              'ts': map_stat[map].last.ts,
              'icon': this.icon_map(map_stat[map]),
              //'icon': ((map_stat[map].last.ts*1000 + 60*60*1000) < new Date().getTime()) ? { url: require('assets/icons/sistematics_offline.png')} : { url: require('assets/icons/sistematics_online.png')},
              'fid': map_stat[map].fid,
              'dev_id': map_stat[map].device_id,
              'full_name': map_stat[map].full_name
            })

            aver_lat += map_stat[map].last.lat
            aver_lng += map_stat[map].last.lng

            list[map] = item
            count++
          }
        }

        this.focus = {
          'lat': aver_lat / count,
          'lng': aver_lng / count
        }
        this.all_coords = list


        this.loading = false
        this.first_req = false
      })
    },
    change_list_ids(data){
      if (!this[data].length > 0){
        if (this.first_req !== false){
          this.all_coords = {}
          this.dashboard_device_map()
        }
      }else{
        this.all_coords = {}
        this.dashboard_device_map()
      }
    },

    deg2rad(deg) {
      return deg * (Math.PI/180)
    },
    clear_find_distance(){
      this.distanceOpen = false
      this.distance_markers = []
    },
    click_find_distance(event){
      if (event.domEvent.ctrlKey) this.add_distance({lat: event.latLng.lat(), lng: event.latLng.lng()}, "first")
    },
    rightclick_find_distance(event){
      if (event.domEvent.ctrlKey) this.add_distance({lat: event.latLng.lat(), lng: event.latLng.lng()}, "second")
    },
    add_distance(elem, type){
      this.distance_markers = this.distance_markers.filter((elem) => {
        if (elem.type !== type) return elem
      })

      let coord = {
        lat: elem.lat,
        lng: elem.lng,
        type: type
      }
      this.distance_markers.push(coord)

      this.openInfoWindowDistance(coord)
    },
    openInfoWindow (item, type) {
      if (event.ctrlKey) this.add_distance({ lat: item.lat, lng: item.lng }, type)
      this.$http.v1.dashboardDeviceInfo(item.fid, (response) => {
        this.device_info = response.data
        this.infoBoxOpen = true
      })

      this.$http.v1.getDeviceSimcards(item.fid, (response) => {
        this.simcard_list = response.data
      })
    },
    closeInfoWindow(){
      this.infoBoxOpen = false
      this.device_info = {}
    },

    openInfoWindowDistance (item) {
      if (this.final_distance) {
        this.distancePos = item
        this.distanceOpen = true
        if (this.final_distance < 999) {
          this.distanceInfo = this.final_distance + ' м'
        }else if (this.final_distance > 4999) {
          this.distanceInfo = (this.final_distance/1000) .toFixed(1) + ' км.'
        }else{
          this.distanceInfo = (this.final_distance/1000).toFixed(2) + ' км.'
        }
      }
    },
  },
}

</script>

<style lang="scss" scoped>

.maps{
  height: calc(100% - 10px);
  margin-top: 10px;
  &--top{
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    @media (max-width: 768px) {
      flex-wrap: wrap;
      height: auto;
    }

    .selects{
      padding: 10px;
      width: 25%;
      min-width: 280px;
      @media (max-width: 768px) {
        width: 100%;
      }
      .select{
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }

    .dashboard_details{
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      padding: 10px;
      width: 100%;
      min-width: 150px;
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (max-width: 500px) {
        flex-wrap: wrap;
        height: auto;
      }
      &--item{
        min-height: 90px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        margin-right: 5px;
        min-width: 150px;
        flex-wrap: wrap;
        @media (max-width: 1200px) {
          min-width: auto;
        }
        @media (max-width: 500px) {
          width: 100%;
          margin: 0 0 5px;
          min-height: auto;
        }

        &:last-child{
          margin-right: 0;
        }

        &.info{
          height: auto;
          p{
            font-size: 14px;
            display: flex;
            align-items: center;
            margin-bottom: 0;
          }
        }
        &.country{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          flex-direction: row;
          justify-content: flex-start;

          .phoca-flag{
            position: relative;
            width: 25px;
            height: 15px;
            box-shadow: none;
            border: none;
            margin: 0 5px 0 0;
          }
          p{
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 100%;
            margin: 0 5px 0 0;
            @media (max-width: 768px) {
              font-size: 14px;
            }
            @media (max-width: 500px) {
              width: 33%;
              margin: 0;
            }
          }
        }
      }
    }
  }

  .card-map{
    position: relative;
    height: calc(100% - 100px);

    .info_window{
      position: absolute;
      height: auto;
      right: 0;
      top: 0;
      width: 280px;
      box-sizing: border-box;
      padding: 5px 20px 5px 5px;
      background-color: #fff;
      z-index: 2;
      transition: 0.2s;

      .close{
        position: absolute;
        right: 0;
        top: 0;
        width: 20px;
        height: 20px;
      }

      .top{
        width: 100%;
        //display: flex;
        //align-items: center;
        //justify-content: center;
        .miniblock {
          width: 100%;
          height: 100px;
          padding: 7.5px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          background-color: #fff;

          &.status_info{
            align-items: center;
            position: relative;

            &.online{
              border-color: #41B883;
              background-color: #41b88330;
              color: #41B883;
            }

            &.offline{
              background-color: #91919130;
              color: #919191;
            }

            &.blocked{
              border-color: #b84141;
              background-color: #b8414130;
              color: #b84141;
            }

            &.backup{
              border-color: #ffb058;
              background-color: #ffb05830;
              color: #d38d47;
              div{
                text-align: center;
              }
            }
            .icons{
              position: absolute;
              left: 0;
              top: 0;
              height: 100% ;
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
              flex-direction: column;
              .icon{
                font-size: 22px;
                line-height: 100%;
                width: 30px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                &.online{
                  font-size: 24px;
                  color: #41B883;
                }
                &.offline{
                  color: #919191;
                }
                &.blocked{
                  color: #b84141;
                }
                &.backup{
                  color: #d38d47;
                }
              }
            }

            .text, .backup{
              text-align: center;
              p{
                font-size: 12px;
                margin: 0;
              }
            }
          }
        }

        .traffic__block{
          display: flex;
          flex-direction: column;
          //margin: 10px 0;
          padding: 5px;
          width: 100%;
          border-bottom: 1px solid #dfdfdf;
          &:last-child{
            border-bottom: none;
          }

          .tariff_name, .rest{
            font-size: 14px;
            text-align: center;
            margin-bottom: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .unlim{
            flex-direction: column;
            span.mdi{
              font-size: 20px;
            }
          }

          .graph{
            &_wrap{
              display: flex;
              align-items: center;
              width: 100%;
              .percent{
                width: 60px;
                margin-right: 10px;
              }
            }
            display: block;
            position: relative;
            width: 100%;
            background: #D5E7FF;
            height: 10px;
            border-radius: 2px;
            overflow-x: hidden;
            margin: 5px 0;
            &::after{
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: var(--lw);
              height: 10px;
              background: var(--c);
              border-radius: 2px 0 0 2px;
            }
          }
        }



      }
      .bottom{
        &__wrap{
          display: flex;
          justify-content: space-between;
          flex-direction: column;
        }
        a, p{
          font-size: 14px;
          margin: 0;
        }
        .device_info{
          margin: 5px 0;
          & a {
            margin-bottom: 5px;
          }
        }
        .simcard_info{
          .response_table{
            padding: 0;
            table {
              .our_sim {
                background-color: #41b88330;
              }
              .sim_status {
                vertical-align: middle;
                position: relative;
                .mdi {
                  position: absolute;
                  top: -1px;
                  left: -2px;
                  font-size: 19px;
                  &::after{
                    content: none;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
  .card-map{
    position: relative;
    .content .row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin: 8px 0;

      .wrap{
        width: 89.5%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
      }
      .btn-apply{
        width: 9.5%;
        padding: 8px 20px;
      }
      .flex-item{
        width: 24%;
        .form-group{
          margin-bottom: 0;
          label{
            font-size: 15px;
            margin-bottom: 5px;
            height: auto;
          }
        }
      }
      &::before{
        content: none;
      }
      &::after{
        content: none;
      }
    }
    .loading{
      position: absolute;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      z-index: 2;
      opacity: 0.5;
    }
  }

  @media (max-width:1150px) {
    .card .content .row {
      flex-direction: column;
      align-items: flex-start;
      .wrap{
        width: 100%;
      }
      .flex-item{
        width: 49%;
        .form-group{
          margin-bottom: 15px;
        }
      }
      .btn-apply{
        width: auto;
      }
    }
  }

  @media (max-width:475px) {
    .card .content .row {
      .flex-item{
        width: 100%;
      }
    }
  }
</style>
